<template>
  <div class="d-flex align-center justify-space-between base-header">
    <div class="d-flex align-center">
      <slot></slot>
      <v-divider vertical class="mx-4"></v-divider>
      <time-picker :settings="settings" :disabled="disabled" v-on="$listeners" />
    </div>
    <icons-and-action-buttons
      class="mr-4"
      :settings="settings"
      :is-addition-disabled="isAdditionDisabled"
      :is-deletion-disabled="isDeletionDisabled"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import IconsAndActionButtons from './IconsAndActionButtons.vue'
import TimePicker from './TimePicker.vue'

export default {
  name: 'BaseHeader',
  components: {
    IconsAndActionButtons,
    TimePicker,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
    isAdditionDisabled: {
      type: Boolean,
      default: false,
    },
    isDeletionDisabled: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.base-header {
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: $cinza-d20;
  letter-spacing: 0.4000000059604645px;
  width: 100%;

  .v-divider {
    height: 24px;
    background-color: rgba(0, 0, 0, 0.12);
  }
}

.text-picker {
  color: #1976d2 !important;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  letter-spacing: 0.4000000059604645px;
}
i.text-picker {
  margin-top: -0.5px;
  margin-left: -0.5px;
}
.text-picker:hover {
  text-decoration: underline;
}
.v-list-item {
  cursor: pointer;
}
</style>
